module.exports = __webpack_public_path__ + "static/media/rubyLogo.ecff70ff.png";